var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeoDiff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_6848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5547 0.5C10.3494 0.5 11.1114 0.815661 11.6733 1.37754C12.2352 1.93942 12.5508 2.7015 12.5508 3.49611C12.5508 4.76147 10.7971 7.5988 9.97316 8.86116C9.9278 8.93081 9.86578 8.98805 9.7927 9.02766C9.71963 9.06728 9.63782 9.08803 9.5547 9.08803C9.47158 9.08803 9.38977 9.06728 9.3167 9.02766C9.24363 8.98805 9.1816 8.93081 9.13624 8.86116C8.31331 7.5978 6.55859 4.76147 6.55859 3.49611C6.55859 2.7015 6.87425 1.93942 7.43613 1.37754C7.99801 0.815661 8.76008 0.5 9.5547 0.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6058 22.5048C11.5145 23.5806 9.08483 23.7939 6.83808 23.0989C4.59132 22.404 2.70644 20.8561 1.58779 18.7874C0.469148 16.7187 0.205857 14.2939 0.854401 12.0333C1.50295 9.7727 3.01166 7.85633 5.05689 6.69531",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0371 6.68848C15.5746 7.57511 16.8168 8.8951 17.6085 10.4835",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.623047 13.4832H4.73272C5.26228 13.483 5.77022 13.6932 6.14488 14.0674L7.14359 15.0661C7.32915 15.2516 7.47635 15.4718 7.57678 15.7142C7.67721 15.9566 7.7289 16.2164 7.7289 16.4788C7.7289 16.7411 7.67721 17.0009 7.57678 17.2433C7.47635 17.4857 7.32915 17.706 7.14359 17.8914L6.14488 18.8901C5.77027 19.2646 5.55976 19.7726 5.55964 20.3023V22.5354",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6092 10.4871H13.0501C12.5204 10.4871 12.0123 10.6975 11.6377 11.0721C11.2631 11.4467 11.0527 11.9547 11.0527 12.4845C11.0519 12.8055 11.1294 13.1219 11.2784 13.4063",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0309 21.5198C19.529 21.5198 21.5541 19.4947 21.5541 16.9966C21.5541 14.4986 19.529 12.4735 17.0309 12.4735C14.5329 12.4735 12.5078 14.4986 12.5078 16.9966C12.5078 19.4947 14.5329 21.5198 17.0309 21.5198Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4937 23.4595L20.25 20.2158",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55469 3.74609C9.41662 3.74609 9.30469 3.63416 9.30469 3.49609C9.30469 3.35802 9.41662 3.24609 9.55469 3.24609",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.55371 3.74609C9.69178 3.74609 9.80371 3.63416 9.80371 3.49609C9.80371 3.35802 9.69178 3.24609 9.55371 3.24609",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_6848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeoDiff);
export default __webpack_public_path__ + "static/media/seo-diff.b49a609103d22a868070fabd7635fe1c.svg";
export { ForwardRef as ReactComponent };